import { Component, Input } from '@angular/core';

@Component({
	selector: 'ui-task-progress-bar',
	template: `
		<div style="min-width: 8rem;">
			<div class="d-flex align-items-center mb-1" *ngIf="!simplifiedMode">
				<div class="text-success mr-3">
					<span class="text-large text-bold">{{ item.hours_booked | decimal:0:2:true }}</span>
					<span>Hours Booked</span>
				</div>
				<div class="text-danger">
					<span class="text-large text-bold">{{ item.hours_over | decimal:0:2:true }}</span>
					<span>Hours Over</span>
				</div>
				<div class="flex-weight-1"></div>
				<div>
					<span class="text-large text-bold">{{ item.total_worked | decimal:0:2:true }}</span>
					<span>Total Duration</span>
				</div>
			</div>
			<div class="d-flex align-items-center mb-2 justify-content-center text-bold" *ngIf="simplifiedMode">
				<div>
					<span [ngClass]="{
						'text-secondary': item.hours_booked === 0,
						'text-danger': item.hours_over > 0 && item.hours_booked !== 0,
						'text-success': item.hours_over === 0 && item.hours_booked !== 0
					}">
						{{ (item.hours_booked + item.hours_over) | decimal:0:2:true }} Hours
					</span>
					<span class="text-secondary"> / {{ item.duration | decimal:0:2:true }} Hours</span>
				</div>
			</div>
			<div class="progress progress-sm">
				<div *ngIf="item.duration > 0" class="progress-bar bg-success" [ngbTooltip]="'Hours Booked: ' + (item.hours_booked | decimal:0:2:true)" [style.width]="getProgressWidth(item.hours_booked, item.duration, 'success')"></div>
				<div class="progress-bar bg-danger" [ngbTooltip]="'Hours Over: ' + (item.hours_over | decimal:0:2:true)" [style.width]="getProgressWidth(item.hours_over, item.duration, 'danger')"></div>
			</div>
		</div>
	`
})
export class UITaskProgressBarComponent {

	@Input() item: any;
	@Input() fontSize: any;
	@Input() simplifiedMode: any = false;

	getProgressWidth(hours: number, totalHours: number, type: string): string {
		if (totalHours === 0) {
			return type === 'danger' && hours > 0 ? '100%' : '0%';
		}
		return `${(hours / totalHours) * 100}%`;
	}

}
